import React, { useEffect, useState } from "react";
import "../../Pages/DashBoard/DashBoard.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Counter from "../../components/Counter/Counter";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import axios from "axios";
import { API_BASE_URL } from "../../utils";
import { useAuthHeaders } from "../../components/Token";
import { Link } from "react-router-dom";
import { Row } from "react-bootstrap";
function DashBoard() {
  const [orderData, setOrderData] = useState([]);

  const headers = useAuthHeaders();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}`, {
        headers,
      })
      .then((res) => {
        setOrderData(res.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  // const cardData = [
  //   { value: <Counter endValue={orderData.shippedCount} />, label: "Order Shipped", color: "" }, 
  //   { value: <Counter endValue={orderData.PaymentsuccessCount} />, label: "Payment Success", color: "bg-success" },
  //   { value: <Counter endValue={orderData.deliveredCount} />, label: "Order Delivered ", color: "bg-warning" },
  //   { value: <Counter endValue={orderData.pendingCount} />, label: "Pending", color: "bg-danger" },
  //   { value: <Counter endValue={orderData.totalOrder} />, label: "Total Order", color: "" },
  //   {
  //     value: <Counter endValue={orderData.totalAmount} />,
  //     label: "Total Amount",
  //     color: "",
  //   },
  // ];

  return (
    <div className=" bg-light">
      <h4 className="text-dark p-4 dashboard-text text-center">DashBoard </h4>

      <div className="row mt-5 me-5 ms-5">
        <div className="col  bg-primary text-white p-3  color-sh ms-2">
          <h6>Total property</h6>

          <p>45</p>
        </div>
        <div className="col p-3 bg-white color-sh ms-2">
          <h6>Total Unit</h6>

          <p>142</p>
        </div>
        <div className="col b p-3 bg-white color-sh  ms-2">
          <h6>Total Income</h6>

          <p>$56456.00</p>
        </div>
        <div className="col p-3 bg-white color-sh ms-2">
          <h6>Total Expense</h6>

          <p>$26456.00</p>
        </div>
      </div>
      <div className="row mt-4 ms-4">
        <div className="col-md-6 bg-white p-3">
          <h6>Payment History</h6>

          <th className=" gap">
            <td className="">Payment Date</td>
            <td className="">Amount</td>
            <td>Status</td>
          </th>
        </div>
      </div>

    </div>
  );
}

export default DashBoard;
